// client/src/components/School_Admin/Dashboard/TeachersPerClassChart.js
//
// THE NURSERY/PRIMARY ANSWER to the question "Teachers per department" asks.
//
// There are no departments in nursery/primary, so that card was showing a
// heading for something the phase does not have — and the series behind it only
// ever approximated one by treating each SUBJECT as its own department. What
// this phase actually has is a CLASS TEACHER per class, plus specialists who
// teach a few subjects into it, so the class is the unit.
//
// Same DistributionPie as its two neighbours on purpose: the three cards sit
// side by side and had already drifted into three different palettes once.

import React from 'react';
import DistributionPie from './DistributionPie';

// Hovering a class names its teachers, class teacher first — the count answers
// "how many" and the question immediately under it is "who".
const TeachersPerClassChart = ({ data }) => (
  <DistributionPie
    items={(Array.isArray(data) ? data : []).map((item) => ({
      label: item.className || item.name || 'Class',
      value: item.count,
      details: Array.isArray(item.teacherNames) ? item.teacherNames : [],
    }))}
    unitLabel="teachers"
    emptyText="No classes with teachers yet"
  />
);

export default TeachersPerClassChart;
